<template>
  <div class="w-100pct h-100-pct">
    <div class="vert w-100-pct h-100-pct bg-wt al-it-c">

      <div class="wid-dyn">
        <navbar v-bind:selindex=1></navbar>
      </div>

      <div class="vert h-100-pct just-space-between wid-dyn">
        <div class="vert just-space-around flex1 bg-p1 p-b-2v p-x-2v">
          <!-- <img class="ml-auto p-2" src="../assets/check.svg" v-on:click="reset" height=44em width=auto /> -->
          <div class="al-l m-t-1-5v">
            <div class="horiz al-it-e just-space-between m-b-0-5v">
              <span class="f0-7 c-c2"> Starting Amount </span>
              <img v-if="selectedcalc===0" class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check.svg"/>
              <img v-else class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/uncheck.svg" @click="selectstart"/>
            </div>
            <div class="horiz" :class=" { 'input-row': selectedcalc!==0, 'output-row': selectedcalc===0 }">
              <span class="c-p4 f0-7 p-x-1v">$</span>
              <formattedNumberResult
                ref="startamount"
                v-model="startAmount"
                :is_result="selectedcalc === 0"
                :result_value="resultStartAmount"
                @showkeypad="show_keypad()"
                @hidekeypad="hide_keypad()" />
              <!-- <input v-if="selectedcalc === 0" type="text" step=0.01 class="flex1 form-control" v-model="resultStartAmount" readonly>
              <input v-else type="text" step=0.01 class="flex1 form-control" v-model="startAmountFmt" @click="select_all($event)"> -->
            </div>
          </div>

          <div class="al-l">
            <div class="horiz al-it-e just-space-between m-b-0-5v">
              <span class="f0-7 c-c2"> Ending Amount </span>
              <img v-if="selectedcalc===1" class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check.svg"/>
              <img v-else class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/uncheck.svg" @click="selectend"/>
            </div>
            <!-- <img class="ml-auto p-2" src="../../static/circle-x.svg" v-on:click="reset" height=44em width=auto /> -->
            <div class="horiz" :class=" { 'input-row': selectedcalc!==1, 'output-row': selectedcalc===1 }">
              <span class="c-p4 f0-7 p-x-1v">$</span>
              <formattedNumberResult
                ref="endamount"
                v-model="endAmount"
                :is_result="selectedcalc === 1"
                :result_value="resultEndAmount"
                @showkeypad="show_keypad()"
                @hidekeypad="hide_keypad()" />
              <!-- <input v-if="selectedcalc === 1" type="text" step=0.01 class="flex1 form-control" v-model="resultEndAmount" readonly>
              <input v-else type="text" step=0.01 class="flex1 form-control" v-model="endAmountFmt" @click="select_all($event)"> -->
            </div>
          </div>

          <div class="al-l">
            <div class="horiz al-it-e just-space-between m-b-0-5v">
              <span class="f0-7 c-c2"> Payment </span>
              <img v-if="selectedcalc===2" class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check.svg"/>
              <img v-else class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/uncheck.svg" @click="selectpayment"/>
            </div>
              <!-- <img class="ml-auto p-2" src="../../static/circle-x.svg" v-on:click="reset" height=44em width=auto /> -->
            <div class="bd-cyan horiz" :class=" { 'input-row': selectedcalc!==2, 'output-row': selectedcalc===2 }">
              <span class="c-p4 f0-7 p-x-1v">$</span>
              <formattedNumberResult
                ref="payment"
                v-model="payment"
                :is_result="selectedcalc === 2"
                :result_value="resultPayment"
                @showkeypad="show_keypad()"
                @hidekeypad="hide_keypad()" />
              <!-- <input v-if="selectedcalc === 2" type="text" step=0.01 class="flex1 form-control" style="flex: 1.5 1 auto" v-model="resultPayment" readonly>
              <input v-else type="text" class="flex1 form-control" style="flex: 1.5 1 auto" v-model="paymentFmt" @click="select_all($event)"> -->
              <div class="horiz al-it-c c-c2 tran-hover p-0-5v r1" @click="togglePaymentRate">
                {{ paymentRate }}
                <img class="m-l-0-5v h-1-5-rem" svg-inline src="@/assets/up-down.svg"/>
              </div>
            </div>
          </div>

          <div class="horiz just-space-between">

            <div class="al-l">
              <div class="horiz al-it-e m-b-0-5v">
                <img v-if="enableTax" class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check-on.svg" @click="toggleTax"/>
                <img v-else class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check-off.svg" @click="toggleTax"/>
                <span class="f0-7 c-c2"> Tax Rate </span>
              </div>
                <!-- <img class="ml-auto p-2" src="../../static/circle-x.svg" v-on:click="reset" height=44em width=auto /> -->
              <div class="bd-red horiz input-row wid-dyn-pair" :class="{ op50: !enableTax }">
                <formattedNumberInput
                  ref="taxpct"
                  v-if="enableTax"
                  v-model="taxPct"
                  @showkeypad="show_keypad()"
                  @hidekeypad="hide_keypad()" />
                <!-- <input v-if="enableTax" type="text" class="flex1" v-model="taxPct" @click="select_all($event)"> -->
                <input v-else type="text" class="op50 flex1" v-model="taxPct" readonly>
                <span class="c-p4 f0-7 p-x-1v" :class="{ op50: !enableTax }">%</span>
              </div>
            </div>

            <div class="al-l">
              <div class="horiz al-it-e just-space-between m-b-0-5v">
                <span class="f0-7 c-c2"> Num years </span>

                <img v-if="selectedcalc===3" class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check.svg"/>
                <img v-else class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/uncheck.svg" @click="selectnumyears"/>
                <!-- <button type="button" class="btn calcbutton input-group-append" v-on:click="selectnumyears"> = </button> -->
              </div>
                <!-- <img class="ml-auto p-2" src="../../static/circle-x.svg" v-on:click="reset" height=44em width=auto /> -->
              <div class="horiz wid-dyn-pair" :class=" { 'input-row': selectedcalc!==3, 'output-row': selectedcalc===3 }">
                <formattedNumberResult
                  ref="numyears"
                  v-model="numYears"
                  :is_result="selectedcalc === 3"
                  :result_value="resultNumYears"
                  @showkeypad="show_keypad()"
                  @hidekeypad="hide_keypad()" />
                <!-- <input v-if="selectedcalc == 3" type="number" step=0.01 class="flex1" v-model="resultNumYears" readonly>
                <input v-else type="text" class="flex1" v-model="numYears" @click="select_all($event)"> -->

              </div>
            </div>

          </div>

          <div class="al-l">
            <div class="horiz al-it-e just-space-between m-b-0-5v">
              <span class="f0-7 c-c2"> Return </span>
              <img v-if="selectedcalc===4" class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/check.svg"/>
              <img v-else class="m1-t m3-r h-1-2-rem" svg-inline src="@/assets/uncheck.svg" @click="selectreturn"/>
            </div>
            <div class="bd-blue horiz" :class=" { 'input-row': selectedcalc!==4, 'output-row': selectedcalc===4 }">
              <formattedNumberResult
                ref="returnpct"
                v-model="returnPct"
                :is_result="selectedcalc === 4"
                :result_value="resultReturnPct"
                @showkeypad="show_keypad()"
                @hidekeypad="hide_keypad()" />
              <span class="c-p4 f0-7 p-x-1v">%</span>
            </div>
            <div v-if="isErrorreturn" class="c-red f0-7"> return must be greater than 0 and less than 12% </div>
          </div>

          <div class="disp-ilb mx-auto p-2v f1-5 shadow1 r1 bg-wt-h cursor-default c-blue" v-on:click="updateResult">Solve</div>
        </div>
        <div class="h-25-vh parent_overlap">
          <clientsAIAd v-if="cur_panel === 0" />
          <numberPad v-if="cur_panel === 1" @number_click="add_num($event)" @backspace_click="add_backspace()" @enter_click="add_enter()" />
          <growthChart class="child_overlap1" :data="chart_data" :prev="prev_data" v-if="cur_panel === 2 || cur_panel === 3" />
          <transition name="fade">
            <growthChart
              v-if="cur_panel === 3"
              class="child_overlap2"
              :data="prev_data"
              :prev="chart_data"
              :faded_colors="true" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const AdPanel = 0
const NumberPanel = 1
const ChartPanel = 2
const PrevChartPanel = 3

import navbar from './navbar.vue'
import formattedNumberResult from './FormattedNumberResult.vue'
import formattedNumberInput from './FormattedNumberInput.vue'
import clientsAIAd from './ClientsAIAd.vue'
import numberPad from './NumberPad.vue'
import growthChart from './GrowthChart.vue'
// import carota from 'carota'
export default {
  name: 'Growth',
  components: {
    navbar,
    formattedNumberInput,
    formattedNumberResult,
    clientsAIAd,
    numberPad,
    growthChart,
  },
  data () {
    return  {
      startAmount: '0',
      taxPct: '24',
      endAmount: '0',
      payment: '0',
      numYears: '10',
      returnPct: '8',
      resultStartAmount: '0',
      resultEndAmount: '0',
      resultPayment: '0',
      resultNumYears: '10',
      resultReturnPct: '8',
      selectedcalc: 2,
      paymentRate: 'Annually',
      compoundPerYear: 1,
      enableTax: true,
      cur_panel: ChartPanel,
      chart_data: [],
      prev_data: [],
      chart_data_id: 0,
      transition: 'fade',
    }
  },
  methods: {
    add_backspace() {
      this.$refs.startamount.delete_char()
      this.$refs.endamount.delete_char()
      this.$refs.payment.delete_char()
      this.$refs.taxpct.delete_char()
      this.$refs.numyears.delete_char()
      this.$refs.returnpct.delete_char()
    },
    add_enter() {
      this.$refs.startamount.on_enter_key()
      this.$refs.endamount.on_enter_key()
      this.$refs.payment.on_enter_key()
      this.$refs.taxpct.on_enter_key()
      this.$refs.numyears.on_enter_key()
      this.$refs.returnpct.on_enter_key()
    },
    add_num(num) {
      console.log('start')
      this.$refs.startamount.append_num(num)
      this.$refs.endamount.append_num(num)
      this.$refs.payment.append_num(num)
      // this.$refs.taxpct.append_num(num)
      this.$refs.numyears.append_num(num)
      this.$refs.returnpct.append_num(num)
      console.log('end')
    },

    show_keypad() {
      this.transition = "fade"
      this.cur_panel = NumberPanel
    },
    hide_keypad() {
      this.transition = "fade"
      this.cur_panel = AdPanel
    },
    select_all(event) {
      event.target.select();
    },
    open_clients() {
      window.open("https://clients-ai.com")
    },
    toggleTax () {
      this.enableTax = !this.enableTax
      // this.$store.dispatch('updateTaxEnable', this.enableTax)
    },

    togglePaymentRate() {
      switch (this.paymentRate) {
        case 'Annually': this.paymentRate = 'Monthly'; break;
        case 'Monthly': this.paymentRate = 'Annually'; break;
      }
      // this.$store.dispatch('updatePaymentRate', this.paymentRate)
    },

    loadAllState () {
      this.startAmount = this.$store.state.startAmount
      this.endAmount = this.$store.state.endAmount
      this.numYears = this.$store.state.numYears
      this.returnPct = this.$store.state.returnPct
      this.taxPct = this.$store.state.taxPct
      this.enableTax = this.$store.state.enableTax
      this.paymentRate = this.$store.state.paymentRate
      console.log(`loaded numYears: ${this.numYears}`)
    },
    storeAllState() {
      const data = {
        startAmount: this.startAmount,
        endAmount: this.endAmount,
        numYears: this.numYears,
        returnPct: this.returnPct,
        taxPct: this.taxPct,
        enableTax: this.enableTax,
        paymentRate: this.paymentRate,
      }
      this.$store.commit('UPDATE_ALL_GROWTH', data)
    },
    reset () {
      this.$store.dispatch('reset')
    },
    formatNumber (newValue) {
      if (typeof(newValue) != "undefined") {
        return newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '0'
      }
    },
    simpleNumber (newValue) {
      return newValue.replace(/\D/g, "")
    },
    selectstart: function () { this.selectedcalc=0; this.resultStartAmount = '' },
    selectend: function () { this.selectedcalc=1; this.resultEndAmount = '' },
    selectpayment: function () { this.selectedcalc=2; this.resultPayment = '' },
    selectnumyears: function () { this.selectedcalc=3; this.resultNumYears = '' },
    selectreturn: function () { this.selectedcalc=4; this.resultReturnPct = '' },
    updateResult: function () {
      this.prev_data = []
      this.chart_data.forEach(item => {
        this.prev_data.push({
          start_value: item.start_value,
          end_value: item.end_value,
          interest: item.interest,
          tax: item.tax,
          payment: item.payment,
          payment1: item.payment1,
          interest1: item.interest1,
          tax1: item.tax1,
          payment2: item.payment2,
          interest2: item.interest2,
          tax2: item.tax2,
        })
      })
      switch (this.selectedcalc) {
        case 0: this.calcStartAmount(); break;
        case 1: this.calcEndAmount(); break;
        case 2: this.calcPayment(); break;
        case 3: this.calcNumYears(); break;
        case 4: this.calcRate(); break;
      }
      this.calcChartData()
      this.transition = "fade"
      this.cur_panel = PrevChartPanel
      setTimeout(() => { this.transition = "fade"; this.cur_panel = ChartPanel }, 500)
    },

    calcChartData: function() {
      const result = []
      let start_value = parseFloat(this.startAmount)
      const cnt = this.paymentsPerYear / this.compoundPerYear
      const k = this.compoundPerYear
      // const rate = this.returnPct * 0.01
      const eff_rate = 0.01 * this.effectiveReturn()
      const rate = 0.01 * this.returnPct
      const taxrate = this.enableTax ? this.taxPct * 0.01 : 0
      const payment = cnt * this.payment
      const annual_payment_interest = (Math.pow(1 + eff_rate / k, k) - 1) / (eff_rate / k)
      let prev_interest = 0
      let prev_tax = 0
      let prev_payment = start_value
      // should compounding change based on payment frequency?
      for (let index=0; index < this.numYears; index += 1) {
        const effective = (payment * annual_payment_interest + start_value * eff_rate) - payment
        const interest = effective / (1 - taxrate)
        const tax = interest - effective
        // const tax = interest_tax * (eff_rate/rate + 1)
        const end_value = start_value + payment + interest - tax
        // const end_value = start_value + payment + interest
        result.push({
          start_value : start_value.toFixed(2),
          end_value: end_value.toFixed(2),
          interest: interest.toFixed(2),
          tax: tax.toFixed(2),
          payment: payment.toFixed(2),
          payment1: (prev_payment).toFixed(2),
          interest1: (prev_payment + prev_interest).toFixed(2),
          tax1: prev_tax.toFixed(2),
          payment2: (prev_payment + payment).toFixed(2),
          interest2: (prev_payment + payment + prev_interest + interest).toFixed(2),
          tax2: (prev_tax + tax).toFixed(2),
        })
        prev_tax += tax
        prev_interest += interest
        prev_payment += payment
        start_value = end_value
        this.chart_data = result
        // console.log(`tax_interest: ${interest_tax}`)
      }
    },

    calcStartAmount: function () {
      var rate = 0.01*this.effectiveReturn()
      var cnt = this.paymentsPerYear / this.compoundPerYear
      var k = this.compoundPerYear
      var n = this.numYears
      var fv = this.endAmount
      var start = (fv - this.payment * cnt * (Math.pow(1 + rate / k, n * k) - 1) / (rate / k)) / Math.pow(1 + rate / k, n * k)
      start = start.toFixed(0)
      this.startAmount = start.toString()
      this.resultStartAmount = this.formatNumber(start.toString())
    },
    calcEndAmount: function () {
      var rate = 0.01*this.effectiveReturn()
      var cnt = this.paymentsPerYear / this.compoundPerYear
      var k = this.compoundPerYear
      var n = this.numYears
      var fv = this.startAmount * Math.pow(1 + rate / k, n * k) + this.payment * cnt * (Math.pow(1 + rate / k, n * k) - 1) / (rate / k)
      fv = fv.toFixed(0)
      this.endAmount = fv.toString()
      this.resultEndAmount = this.formatNumber(fv.toString())
    },
    calcPayment: function () {
      var rate = 0.01*this.effectiveReturn()
      var cnt = this.paymentsPerYear / this.compoundPerYear
      var k = this.compoundPerYear
      var n = this.numYears
      var payment = (this.endAmount - this.startAmount * Math.pow(1 + rate / k, n * k)) / ((Math.pow(1 + rate / k, n * k) - 1) / (rate / k)) / cnt
      payment = Math.max(0, payment.toFixed(0))
      this.payment = payment.toString()
      this.resultPayment = this.formatNumber(this.payment.toString())
    },
    calcRate: function () {
      var taxPct = this.enableTax ? this.taxPct : 0
      var cnt = this.paymentsPerYear / this.compoundPerYear
      var k = this.compoundPerYear
      var n = this.numYears
      var rate = 0.0001
      var fv = this.startAmount * Math.pow(1 + rate / k, n * k) + this.payment * cnt * (Math.pow(1 + rate / k, n * k) - 1) / (rate / k)
      while ((fv < this.endAmount) && (rate < 100)) {
        fv = this.startAmount * Math.pow(1 + rate / k, n * k) + this.payment * cnt * (Math.pow(1 + rate / k, n * k) - 1) / (rate / k)
        rate = rate + 0.0001
      }
      rate = rate - 0.0001
      this.returnPct=((100*rate) / (1 - 0.01 * taxPct)).toFixed(0)
      this.resultReturnPct = ((100*rate) / (1 - 0.01 * taxPct)).toFixed(1)
      console.log(`returnPct: ${this.returnPct}`)
    },
    calcNumYears: function () {
      var rate = 0.01*this.effectiveReturn()
      var cnt = this.paymentsPerYear / this.compoundPerYear
      var k = this.compoundPerYear
      var n = 0
      var fv = this.startAmount * Math.pow(1 + rate / k, n * k) + this.payment * cnt * (Math.pow(1 + rate / k, n * k) - 1) / (rate / k)
      while ((fv < this.endAmount) && (n < 100)) {
        fv = this.startAmount * Math.pow(1 + rate / k, n * k) + this.payment * cnt * (Math.pow(1 + rate / k, n * k) - 1) / (rate / k)
        n = n + 0.01
      }
      this.resultNumYears= n.toFixed(0)
      this.numYears = n.toFixed(0)
    },

    effectiveReturn: function () {
      if (this.enableTax) {
        return (1 - 0.01 * this.taxPct) * this.returnPct
      } else {
        return this.returnPct
      }
    }

  },
  watch: {
    resetCount: function () {
      this.loadAllState()
    },
  },
  computed: {
    resetCount: function () {
      return this.$store.state.resetCount
    },
    paymentsPerYear: function () {
      switch (this.paymentRate) {
        case "Annually": return 1;
        case "SemiAnnually": return 2;
        case "Quarterly": return 4;
        case "Monthly": return 12;
      }
      return 12
    },
    isErrorreturn: function () {
      var isnumeric = !isNaN(parseFloat(this.returnPct)) && isFinite(this.returnPct)
      return (!isnumeric || (parseFloat(this.returnPct) < 0) || (parseFloat(this.returnPct) > 12))
    },
  },
  created() {
    this.loadAllState()
  },
  destroyed() {
    this.storeAllState()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-left {
  text-align: left
}
.result {
  background-color: #ffffe0;
  color: #000000 !important;
}
input {
  text-align: center
}
.lightbox {
  background-color: #f7f8f9;
  border-radius: 0.5em
}
.calcbutton {
  background-color: #e9ecef;
  border-color: rgb(206,212,218);
}
.fullwidth {
  width: 100%
}
.form-control[readonly] {
  color: #000000;
}
label {
  margin-top: 0.5em
}
input:invalid {
  border: 5px solid #ffdddd
}

.tran-hover:hover {
  background-color: #c0c0c040;
  box-shadow: var(--button-shadow);
}

.slide-enter {
  opacity: 0;
  transform: translate3d(0, 25vh, 0);
}

.slide-enter-to { transform: scale3d(1, 1, 1); }
.slide-enter-active { transition: 0.2s ease-out; }

.bd-blue { border-left: 1.5vmin solid var(--blue) }
.bd-red { border-left: 1.5vmin solid var(--red)}
.bd-cyan { border-left: 1.5vmin solid var(--cyan)}

.parent_overlap {
  position: relative
}
.child_overlap1 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;
}
.child_overlap2 {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>

